export const formatTime = (oldDate) => {
  let newDate = new Date(oldDate).toLocaleTimeString("en-GB", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
  return newDate.replace("am", "AM").replace("pm", "PM");
};
